import { render, staticRenderFns } from "./PsiFormCurrencyField.vue?vue&type=template&id=033374ff&"
import script from "./PsiFormCurrencyField.vue?vue&type=script&lang=js&"
export * from "./PsiFormCurrencyField.vue?vue&type=script&lang=js&"
import style0 from "./PsiFormCurrencyField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports